import React from 'react';

export const ShopFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="mb-8">
      <div className="flex flex-wrap justify-center gap-2">
        {categories.map(category => (
          <button
            key={category.id}
            className={`px-4 py-2 rounded-md transition-colors ${
              selectedCategory === category.id 
                ? 'bg-green-400 text-black' 
                : 'bg-gray-700 text-white hover:bg-gray-600'
            }`}
            onClick={() => onCategoryChange(category.id)}
            id={category.id}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}; 